import { getRangeLabel } from '../../../../utils/getRangeLabel'
import type { DateRangeValue } from '../AnalyticsDateRangeSelect.types'

export const getValueLabel = (value: DateRangeValue) => {
  if (value.label) {
    return value.label
  }

  return getRangeLabel(value.dates)
}
